var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: {
        scrollable: "",
        "max-width": "100%",
        transition: "dialog-transition"
      },
      on: {
        input: function($event) {
          return _vm.close()
        }
      },
      model: {
        value: _vm.show,
        callback: function($$v) {
          _vm.show = $$v
        },
        expression: "show"
      }
    },
    [
      _c(
        "v-card",
        { staticClass: "background" },
        [
          _c(
            "v-card-title",
            {
              staticClass:
                "py-1 px-3 primary color--text subheading word-break-all"
            },
            [
              _c(
                "v-btn",
                {
                  staticClass: "my-0",
                  attrs: { flat: "", icon: "", color: "color" },
                  on: {
                    click: function($event) {
                      return _vm.openFile()
                    }
                  }
                },
                [_c("v-icon", [_vm._v("folder")])],
                1
              ),
              _vm._v("\n\t\t\t" + _vm._s(_vm.file_path) + "\n\t\t\t"),
              _c("v-spacer"),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  staticClass: "my-0",
                  attrs: { flat: "", icon: "", color: "color" },
                  on: {
                    click: function($event) {
                      return _vm.close()
                    }
                  }
                },
                [_c("v-icon", [_vm._v("close")])],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _vm.show
            ? _c(
                "v-card-text",
                { staticClass: "pa-0", staticStyle: { height: "80vh" } },
                [
                  _vm.loading || _vm.error
                    ? _c(
                        "v-container",
                        { attrs: { "grid-list-xs": "" } },
                        [
                          _vm.loading
                            ? _c("v-progress-linear", {
                                attrs: { color: "primary", indeterminate: "" }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "v-alert",
                            {
                              staticClass: "pa-2 ma-0",
                              attrs: {
                                type: "error",
                                value: _vm.error !== null
                              }
                            },
                            [
                              _vm._v(
                                "\n\t\t\t\t\t" +
                                  _vm._s(_vm.error) +
                                  "\n\t\t\t\t"
                              )
                            ]
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.loading && _vm.file_content
                    ? _c("AceEditor", {
                        attrs: {
                          code: _vm.file_content,
                          theme: "monokai",
                          height: "100%",
                          width: "100%",
                          language: _vm.language,
                          readonly: true
                        }
                      })
                    : _vm._e()
                ],
                1
              )
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-761eac34", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-761eac34","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./build/scramble/app-loader.js!./src/components/file_reader_modal.vue
// module id = null
// module chunks = 